import React, { useState, useEffect } from "react";
import "./style.scss";
import { LoadingOutlined } from "@ant-design/icons";
import MenuCard from "../../../components/Card";
import { Layout, Space, PageHeader, Row, Col } from "antd";
import R2Footer from "../../../components/Footer";
import { useHistory } from "react-router";
import modes from "../../../components/view-modes";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PosService from "../../../services/PosService";
const { Content } = Layout;

const POSMenus = (props) => {
  const [loading, setLoading] = useState(true);
  const [menus, setMenus] = useState([]);
  const history = useHistory();

  const getMenus = async () => {
    const restaurant_id = props.adminRestaurant;
    const data = await PosService.posMenu(restaurant_id);
    if(data)
      setMenus(data.menus);
    setLoading(false);
  };

  useEffect(() => {
    getMenus();
  }, [props.adminRestaurant]);

  return (
    <Layout style={{ padding: "0 18px 8px" }}>
      <Content
        className=""
        style={{
          padding: 10,
          margin: "8px 0px",
          minHeight: 280,
          position: "relative",
        }}
      >
        {loading ? (
          <LoadingOutlined style={{ fontSize: "30px" }} />
        ) : (
          <Space direction="vertical" style={{ width: "100%" }}>
            <PageHeader title="POS Menu Section"
            className="page-header-business" />
            <Row>
              {menus.map((menu, index) => (
                <Col
                  className="gutter-row relative menu_cardmain"
                  key={menu.id}
                >
                  <MenuCard
                    data={menu} onEdit={()=>
                      history.push(
                        `/edit-menu/${menu.id}`
                      )
                    }
                    onView={(id)=>
                      {
                        localStorage.setItem("menuId",id)
                      history.push(`/pos/menus/server-menu?id=${id}`)
                      }
                    }
                  />
                </Col>
              ))}
            </Row>
          </Space>
        )}
      </Content>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};

export default withRouter(connect(mapStateToProps)(POSMenus));
